import { Dispatch } from "@reduxjs/toolkit";
import { api } from "../config/api";
import { GetState } from "../config/store";
import {
    getFilterMyPublicationsRequest,
    getFilterMyPublicationsSuccess,
    getFilterMyPublicationsFailure,
    cleanFilterMyPublications as cleanFilterMyPublicationsReducer,
    cleanDataFiltersMyPublications as cleanDataFiltersMyPublicationsReducer,
    getStatusPublicationRequest,
    getStatusPublicationSuccess,
    getStatusPublicationFailure,
    cleanStatusPublication as cleanStatusPublicationReducer,
    setSearchMyPublications as setSearchMyPublicationsReducer,
    setStatesMyPublications as setStatesMyPublicationsReducer,
    setBranchesMyPublications as setBranchesMyPublicationsReducer,
    setYearsMyPublications as setYearsMyPublicationsReducer,
    setSellersMyPublications as setSellersMyPublicationsReducer,
} from "../reducers/profile";
import { axiosClient } from "../config/axios";
import { setPublicationForNews as setPublicationForNewsReducer } from "../reducers/publication";
import { catch401 } from "../helpers/actions";

export const filterMyPublications = (filters: any, page?: number, limit?: number, condition?: string) => (dispatch: Dispatch) => _filterMyPublications(filters, page, limit, dispatch, condition);
const _filterMyPublications = async (filters: any, page = 1, limit = 20, dispatch: Dispatch, condition?: string) => {
    try {
        dispatch({ type: getFilterMyPublicationsRequest });

        let url = "";
        let states = "";
        let branches = "";
        let years = "";
        let sellers = "";

        if(filters?.states && filters?.states.length > 0){
            filters.states.forEach((state: any) => {
                states = states.concat(state.id + ",")
            })
            url = states ? `status=${states.slice(0, -1)}` : "";
        }

        if(filters?.branches && filters?.branches.length > 0){
            filters.branches.forEach((branch: any) => {
                branches = branches.concat(branch.id + ",")
            })
            url = url + `${url ? '&' : ''}branch=${branches.slice(0, -1)}`;
        }

        if (filters?.years && filters?.years.length > 0) {
            filters.years.forEach((year: any) => {
                years = years.concat(year.name + ",")
            })
            url = url + `${url ? '&' : ''}article.year=1,${years.slice(0, -1)}`;
        }

        if (filters?.sellers && filters?.sellers.length > 0) {
            filters.sellers.forEach((seller: any) => {
                sellers = sellers.concat(seller.id + ",")
            })
            url = url + `${url ? '&' : ''}seller=${sellers.slice(0, -1)}`;
        }

        if (filters?.text && filters?.text.length > 0) {
            url = url + `${url ? '&' : ''}text=${filters?.text}`;
        }

        if (url) {
            url = url + "&";
        }

        const response = await axiosClient.get(`${api.publications}/my-publications?${url}&page=${page}&limit=${limit}${condition === 'new' ? `&condition=${condition}` : ""}`);

        dispatch({ type: getFilterMyPublicationsSuccess, payload: response?.data?.data });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getFilterMyPublicationsFailure });
    }
}

export const cleanFilterMyPublications = () => (dispatch: Dispatch) => _cleanFilterMyPublications(dispatch);
const _cleanFilterMyPublications = (dispatch: Dispatch) => dispatch({type: cleanFilterMyPublicationsReducer});

export const cleanDataFiltersMyPublications = () => (dispatch: Dispatch) => _cleanDataFiltersMyPublications(dispatch);
const _cleanDataFiltersMyPublications = (dispatch: Dispatch) => dispatch({type: cleanDataFiltersMyPublicationsReducer});

export const getStatusPublication = () => (dispatch: Dispatch) => _getStatusPublication(dispatch);
const _getStatusPublication = async (dispatch: Dispatch) => {
    try {
        dispatch({ type: getStatusPublicationRequest });

        const response = await axiosClient.get(`${api.publications}/status`);

        dispatch({ type: getStatusPublicationSuccess, payload: response?.data?.data?.statuses });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getStatusPublicationFailure });
    }
}

export const cleanStatusPublication = () => (dispatch: Dispatch) => _cleanStatusPublication(dispatch);
const _cleanStatusPublication = (dispatch: Dispatch) => dispatch({type: cleanStatusPublicationReducer});

export const setSearchMyPublications = (text: any) => (dispatch: Dispatch) => _setSearchMyPublications(text, dispatch);
const _setSearchMyPublications = (text: any, dispatch: Dispatch) => dispatch({type: setSearchMyPublicationsReducer, payload: text});

export const setStatesMyPublications = (status: any) => (dispatch: Dispatch) => _setStatesMyPublications(status, dispatch);
const _setStatesMyPublications = (status: any, dispatch: Dispatch) => dispatch({type: setStatesMyPublicationsReducer, payload: status});

export const setBranchesMyPublications = (branches: any) => (dispatch: Dispatch) => _setBranchesMyPublications(branches, dispatch);
const _setBranchesMyPublications = (branches: any, dispatch: Dispatch) => dispatch({type: setBranchesMyPublicationsReducer, payload: branches});

export const setYearsMyPublications = (years: any) => (dispatch: Dispatch) => _setYearsMyPublications(years, dispatch);
const _setYearsMyPublications = (years: any, dispatch: Dispatch) => dispatch({type: setYearsMyPublicationsReducer, payload: years});

export const setSellersMyPublications = (sellers: any) => (dispatch: Dispatch) => _setSellersMyPublications(sellers, dispatch);
const _setSellersMyPublications = (sellers: any, dispatch: Dispatch) => dispatch({type: setSellersMyPublicationsReducer, payload: sellers});

export const setPublicationForNews = (publication: any) => (dispatch: Dispatch) =>_setPublicationForNews(publication, dispatch);
const _setPublicationForNews = (publication: any, dispatch: Dispatch) => dispatch({type: setPublicationForNewsReducer, payload: publication})